import axios from './axios';

const api = {
  /**
   * GET request with optional query params
   */
  get: (url, params = {}) =>
    axios.get(url, { params }),

  /**
   * POST request with JSON or FormData
   */
  post: (url, data) => {
    const headers = {};

    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    return axios.post(url, data, { headers });
  },

  /**
   * PUT request with JSON or FormData
   */
  put: (url, data) => {
    const headers = {};

    if (data instanceof FormData) {
      headers['Content-Type'] = 'multipart/form-data';
    }

    return axios.put(url, data, { headers });
  },

  /**
   * PATCH request
   */
  patch: (url, data) => axios.patch(url, data),

  /**
   * DELETE request (with optional data in body)
   */
  delete: (url, data = {}) =>
    axios.delete(url, { data }),
};

export default api;
